import { subDays } from "date-fns";
import _ from "lodash";

/**
 * Budget year for an in-market / ship date.
 * For 2026+ the API subtracts 14 days so late-December shipments don't spill into the next year.
 */
export const getFiscalYear = (date: Date) => {
  return subDays(date, 14).getFullYear();
};

export const yearToFY = (year: number) => `FY${year - 2000}`;

/**
 * Gallo fiscal year for a calendar date.
 * The fiscal year starts October 1. E.g. Oct 1st 2023 is the start of FY24.
 */
export const getCurrentFiscalYearNumber = (date: Date) => {
  const year = date.getFullYear();
  return date.getMonth() >= 9 ? year + 1 : year;
};

const currentFiscalYearNumber = getCurrentFiscalYearNumber(new Date());
const END_YEAR = currentFiscalYearNumber + 1;

const getCurrentFiscalYear = () => yearToFY(currentFiscalYearNumber);

const fiscalYearOptions = _.range(currentFiscalYearNumber, END_YEAR + 1)
  .reverse()
  .map(yearToFY)
  .map((fy) => ({ id: fy, name: fy }));

const fiscalYear = {
  current: getCurrentFiscalYear,
  options: fiscalYearOptions,
};

export default fiscalYear;
